import actionTypes from './actionTypes';

export const initialState = {
  awsConnectionStatus: 'Pending', // values: 'Pending', 'Error', 'Success',
  awsConnectionError: {},
  displayOnlyRequiredInfoFields: false,
  currentLibraryId: 0,
  currentLibraryName: '',
  currentCollectionId: 0,
  currentCollectionName: '',
  notificationDomRef: {},
  confirmDialogCompleted: false,
  activeAccordionIndex: 0,
  heartbeatIds: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.setAwsConnectionStatus:
      return {
        ...state,
        awsConnectionStatus: action.status,
        awsConnectionError: action.error,
      };
    case actionTypes.setDisplayOnlyRequiredInfoFields:
      return { ...state, displayOnlyRequiredInfoFields: action.value };
    case actionTypes.setCurrentTrialName:
      return { ...state, currentTrialName: action.value };
    case actionTypes.setCurrentLibraryId:
      return { ...state, currentLibraryId: action.value };
    case actionTypes.setCurrentLibraryName:
      return { ...state, currentLibraryName: action.value };
    case actionTypes.setCurrentCollectionId:
      return { ...state, currentCollectionId: action.value };
    case actionTypes.setCurrentCollectionName:
      return { ...state, currentCollectionName: action.value };
    case actionTypes.setAuthenticityToken:
      return { ...state, authenticityToken: action.token };
    case actionTypes.setNotificationDomRef:
      return { ...state, notificationDomRef: action.notificationDomRef };
    case actionTypes.setConfirmDialogCompleted:
      return { ...state, confirmDialogCompleted: action.value };
    case actionTypes.startHeartbeat:
      return state;
    case actionTypes.setActiveAccordionIndex:
      return { ...state, activeAccordionIndex: action.fileIndex };
    case actionTypes.addHeartbeatId:
      return { ...state, heartbeatIds: [...state.heartbeatIds, action.payload] };
    case actionTypes.removeHeartbeatId:
      if (action.fileIndex === null) {
        return { ...state, heartbeatIds: [] };
      }
      return {
        ...state,
        heartbeatIds: state.heartbeatIds.filter((f, i) => {
          return f.fileIndex !== action.fileIndex;
        }),
      };
    default:
      return state;
  }
}

export default reducer;
